import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import DefaultLayout from '../layouts/DefaultLayout';
import { fetchWithAuth } from '../services/Fetch';
import Stat from '../interfaces/Stat';
import Chart from 'react-google-charts';

const Home: React.FC = () => {
    const [stats, setStats] = useState<Stat>({
        numberOfProjects: 0,
        numberOfProjectsWithRecentAudit: 0,
        numberOfProjectsWithoutRecentAudit: 0,
        projectsToBeReviewed: [],
        projectWithNpmVulnerability: 0,
        projectWithoutNpmVulnerability: 0,
        projectWithComposerVulnerability: 0,
        projectWithoutComposerVulnerability: 0,
    });

    const fetchStats = async () => {
        try {
            const response = await fetchWithAuth('/stats');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setStats(data as Stat);
        } catch (error) {
            console.error('Error fetching stats:', error);
        }
    }

    useEffect(() => {
        fetchStats();

    }, []);

    return (
        <DefaultLayout>
            <div className="row mb-3">
                <div className="col-sm-6 mb-2">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Projets</h5>
                            <p className="card-text">Voir les différents projets disponible dans la console de sécurité.</p>
                            <Link className="btn btn-primary" to="/projects">Voir les {stats.numberOfProjects} projets</Link>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 mb-2">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Clients</h5>
                            <p className="card-text">Voir les différents clients disponible dans la console de sécurité.</p>
                            <Link className="btn btn-primary" to="/customers">Voir les clients</Link>
                        </div>
                    </div>
                </div>
            </div>
            <h3 className='mb-5'>Tableau de bord</h3>
            <div className='row'>
                <div className='col-12 col-md-4'>
                    <h4>Projet avec vulnérabilité NPM</h4>
                    <Chart
                        chartType="PieChart"
                        data={[
                            ["Conformité", "Nombre de projet"],
                            ["Avec vulnérabilité", stats.projectWithNpmVulnerability],
                            ["Sans vulnérabilité", stats.projectWithoutNpmVulnerability],
                        ]}
                        width={"100%"}
                        height={"350px"}
                        options={{
                            legend: {
                                position: "bottom",
                                alignment: "center",
                            },
                            colors: ["#e4130c", "#11bb28"]
                        }}
                    />
                </div>
                <div className='col-12 col-md-4'>
                    <h4>Projet avec vulnérabilité Composer</h4>
                    <Chart
                        chartType="PieChart"
                        data={[
                            ["Conformité", "Nombre de projet"],
                            ["Avec vulnérabilité", stats.projectWithComposerVulnerability],
                            ["Sans vulnérabilité", stats.projectWithoutComposerVulnerability],
                        ]}
                        width={"100%"}
                        height={"350px"}
                        options={{
                            legend: {
                                position: "bottom",
                                alignment: "center",
                            },
                            colors: ["#e4130c", "#11bb28"]
                        }}
                    />
                </div>
                <div className='col-12 col-md-4'>
                    <h4>Etat des audits à 30 jours</h4>
                    <Chart
                        chartType="PieChart"
                        data={[
                            ["Conformité", "Nombre de projet"],
                            ["Projets pas audités ou il y a plus de 30 jours", stats.numberOfProjectsWithoutRecentAudit],
                            ["Projets audités il y a moins de 30 jours", stats.numberOfProjectsWithRecentAudit],
                        ]}
                        width={"100%"}
                        height={"350px"}
                        options={{
                            legend: {
                                position: "bottom",
                                alignment: "center",
                            },
                            colors: ["#e4130c", "#11bb28"]
                        }}
                    />
                </div>
                <div className='col-12'>
                    <h4>Projet nécessistant un revue</h4>
                    <table className="table table-striped mt-3">
                        <thead>
                            <tr>
                                <th scope="col">Nom</th>
                                <th scope="col">Causes</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {stats.projectsToBeReviewed.map(project => <tr key={project.id}>
                                <td>{project.customer} - {project.name}</td>
                                <td><ul>{project.causes?.map(c => <li key={c}>{c}</li>)}</ul></td>
                                <td>
                                    <Link to={`/projects/${project.id}`} className="btn btn-primary">
                                        Voir les rapports
                                    </Link>
                                    <Link to={`/projects/${project.id}/edit`} className="btn btn-secondary ms-2">
                                        Modifier
                                    </Link>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
            </div>
        </DefaultLayout>
    );
}

export default Home;